module.exports = __webpack_public_path__ + "static/media/ic_close.c32fdad4.svg";